<template>
    <div class="fill-height d-flex flex-column of-y" >
        <app-partner-admin v-if="$store.state.ref.partner.tabIndex === 0"/>
        <app-partner-sites v-if="$store.state.ref.partner.tabIndex === 1"/>
        <app-partner-manage v-if="$store.state.ref.partner.tabIndex === 4"/>
        <app-partner-partners v-if="$store.state.ref.partner.tabIndex === 3"/>
        <app-site-management v-if="$store.state.ref.partner.tabIndex === 5"/>
    </div>
</template>

<script>
import AppPartnerAdmin from "@/components/Partner/AppPartnerAdmin";
import AppPartnerSites from "@/components/Partner/AppPartnerSites";
import AppPartnerManage from "@/components/Partner/AppPartnerManage";
import AppPartnerPartners from "@/components/Partner/AppPartnerPartners";
import AppSiteManagement from "@/components/Partner/AppSiteManagement";
export default {
    name: "AppPartner",
    components: {AppPartnerPartners, AppPartnerManage, AppPartnerSites, AppPartnerAdmin, AppSiteManagement}
}
</script>

<style scoped>

</style>